import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchProductLink } from 'redux/catalog/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './ProductItemUrl.css';

const ENTER_KEY = 13;


class ProductItemUrl extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    location: PropTypes.object,
    productId: PropTypes.number.isRequired,
    patchProductLinkError: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    patchProductLinkError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.url) {
      this.setState({
        initialValue: this.props.url,
        currentValue: this.props.url,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.setState({ currentValue: this.props.url });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeProductUrl = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('url', currentValue);
      this.props.patchProductLink(this.props.productId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeProductUrl();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeProductUrl();
  };

  executeValidation = () => {
    const { patchProductLinkError } = this.props;
    const { currentValue } = this.state;

    if (patchProductLinkError && patchProductLinkError.url) {
      return patchProductLinkError.url;
    }
    if (currentValue === '' ) {
      return 'Product Url should not be empty';
    }
    return null;
  };

  render() {
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="product-item-url__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">{t("Product Link")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchProductLinkError: state.catalogReducer.patchProductLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(onClickOutside(ProductItemUrl));
